// extracted by mini-css-extract-plugin
export default {"ul":"list-module--ul--0dff3","ol":"list-module--ol--b8280","noMargin":"list-module--no-margin--771ca","li":"list-module--li--b06b7"};